import { h, Host } from "@stencil/core";
import { BEM } from "../../utils/bem";
export class Stage {
    constructor() {
        this.getContainerWidth = () => {
            switch (this.containerSize) {
                case 'is-detail-page':
                case 'detail-page':
                    return '680px';
                case 'is-compact':
                case 'compact':
                    return '832px';
                case 'is-blog-page':
                case 'blog-page':
                    return '920px';
                case 'is-fluid':
                case 'fluid':
                    return '100vw';
                case 'is-wide':
                case 'wide':
                default:
                    return '1400px';
            }
        };
        this.containerSize = '';
        this.size = '';
        this.color = 'purple';
        this.shape = false;
        this.shapeVariation = undefined;
        this.shapeRotation = undefined;
    }
    get containerClass() {
        if (this.containerSize.includes('wide')) {
            return '';
        }
        if (this.containerSize.startsWith('is-')) {
            return this.containerSize;
        }
        return `is-${this.containerSize}`;
    }
    render() {
        const block = BEM.block('stage');
        const element = BEM.block('stage-content');
        return (h(Host, { key: '26fa68309540d2090168e70d745466c73e2d524e', class: Object.assign(Object.assign(Object.assign(Object.assign({}, block.class()), block.modifier(`is-${this.size === '' ? 'medium' : this.size}`).class()), block.modifier(`is-${this.color}`).class(!!this.color)), block.modifier('has-shape').class(!!this.shape)), style: { '--bal-stage-container-width': this.getContainerWidth() } }, h("section", { key: 'b3939e386e53ff9479d3ee51d0d5e9fd0662f77d', class: Object.assign(Object.assign({}, element.class()), { container: true, [`${this.containerClass}`]: this.containerSize !== '' }) }, h("slot", { key: '80d5fad8974eb06f8fb502d15e5f4915a01b3ee2' }), this.shape && (h("div", { key: '1664151ee5558d9bc2f51621f05b5bfa9f872728', class: { container: true, [`${this.containerClass}`]: this.containerSize !== '' } }, h("bal-shape", { key: '89ed4edbe57ad2a4c8d3016a8654eb4918124451', color: this.color, variation: this.shapeVariation, rotation: this.shapeRotation }))))));
    }
    static get is() { return "bal-stage"; }
    static get originalStyleUrls() {
        return {
            "$": ["bal-stage.sass"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["bal-stage.css"]
        };
    }
    static get properties() {
        return {
            "containerSize": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalStageContainer",
                    "resolved": "string",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines content width of the stage"
                },
                "getter": false,
                "setter": false,
                "attribute": "container-size",
                "reflect": false,
                "defaultValue": "''"
            },
            "size": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalStageSize",
                    "resolved": "\"\" | \"large\" | \"small\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines size of the stage"
                },
                "getter": false,
                "setter": false,
                "attribute": "size",
                "reflect": false,
                "defaultValue": "''"
            },
            "color": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalStageColor",
                    "resolved": "\"blue\" | \"green\" | \"purple\" | \"red\" | \"yellow\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines the background color of the stage section"
                },
                "getter": false,
                "setter": false,
                "attribute": "color",
                "reflect": false,
                "defaultValue": "'purple'"
            },
            "shape": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If true the Baloise Shape is set"
                },
                "getter": false,
                "setter": false,
                "attribute": "shape",
                "reflect": false,
                "defaultValue": "false"
            },
            "shapeVariation": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalShapeVariation",
                    "resolved": "\"1\" | \"2\" | \"3\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Shape Variation"
                },
                "getter": false,
                "setter": false,
                "attribute": "shape-variation",
                "reflect": false
            },
            "shapeRotation": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "BalProps.BalShapeRotation",
                    "resolved": "\"0\" | \"180\" | \"270\" | \"90\"",
                    "references": {
                        "BalProps": {
                            "location": "global",
                            "id": "global::BalProps"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Shape Rotation"
                },
                "getter": false,
                "setter": false,
                "attribute": "shape-rotation",
                "reflect": false
            }
        };
    }
}
